import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface HiddenCaptchaProps {
  currentLanguage: string;
}

interface HiddenCaptchaState {
  captcha: string | null;
}

export interface HiddenCaptchaRef {
  getCaptchaAsync: () => Promise<string | null | undefined>;
}

const HiddenCaptcha: React.ForwardRefRenderFunction<HiddenCaptchaRef, HiddenCaptchaProps> = (props, ref) => {
  const recaptchaRef = React.useRef<ReCAPTCHA>(null);
  const [state, setState] = React.useState<HiddenCaptchaState>({ captcha: null });

  React.useImperativeHandle(ref, () => ({
    getCaptchaAsync: async () => {
      if (state?.captcha) {
        return state.captcha;
      }
      if (recaptchaRef?.current?.getValue()) {
        const token = recaptchaRef?.current?.getValue();
        setState({ captcha: token });
        return token;
      }
      try {
        const token = await recaptchaRef?.current?.executeAsync();
        setState({ captcha: token ?? null });
        return token;
      } catch (e) {
        console.error(e);
        recaptchaRef?.current?.execute();
        const token = recaptchaRef?.current?.getValue();
        setState({ captcha: token ?? null });
        return token;
      }
    },
  }));

  React.useEffect(() => {
    if (!document.getElementById('captchaStyle')) {
      const styleElement = document.createElement('style');
      styleElement.id = 'captchaStyle';
      document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    // @ts-ignore
    document.getElementById('captchaStyle').innerText = '.grecaptcha-badge {width: 0 !important;height: 0 !important;}';
  }, []);

  const onChange = (str: string | null) => {
    setState({ captcha: str });
  };

  const onError = () => {
    setState({ captcha: '' });
  };

  const onExpire = () => {
    setState({ captcha: '' });
  };

  const { currentLanguage } = props;
  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      onErrored={onError}
      onChange={onChange}
      onExpired={onExpire}
      hl={currentLanguage}
      size="invisible"
      sitekey="6LdY4dEpAAAAAKX9qFoYShRz95Ca2S5fT6mK9zKt"
    />
  );
};

export default React.forwardRef(HiddenCaptcha);
